<script>
    import EducatorBasic from './EducatorTemplate/EducatorBasic'
    import EducatorIntro from './EducatorTemplate/EducatorIntro'
    import EducatorClasses from './EducatorTemplate/EducatorClasses'

    export default {
        components: {
            EducatorBasic,
            EducatorIntro,
            EducatorClasses
        },      
        props: ['educator', 'educatorID', 'editable'],
        mounted () {   

        },
        data() {
            return {
                foo: "bar"
            }
        },         
        methods: {      
          save() {
            console.log("we've got to save the educator!")
            this.$store.commit('saveEducator', this.educator)
          }
        }
        
    }
</script>

<template lang="pug">
#company-info
  #company-container.row 
    .col.s12.m12.l6
      educator-basic( :educator="educator" @save="save" :educatorID="educatorID" :editable="editable")
      educator-intro( :educator="educator" @save="save" :educatorID="educatorID" :editable="editable")
    .col.s12.m12.l6
      educator-classes( :educator="educator" @save="save" :educatorID="educatorID" :editable="editable")
    .col.s12.m12.l12
      p &nbsp;        

</template>

<style lang="sass">

#company-container.row
  padding-left: 20px;
  padding-right: 20px;

@media screen and (min-width: 1500px)
  #company-container.row
    padding-left: 100px;
    padding-right: 100px; 

.form-label
   margin: 0 !important;


.input-div
    padding: 0 .5em 0 .5em !important;
    margin: 8px !important;
    border: 2px solid #000 !important;


// modal styles
.modal-overlay2
  display: block;
  z-index: 4000;
  height: 100vh;
  width: 100vw;
  background-color: rgba(1,1,1,.5);
  top: 0px
  left: 0px
  position: fixed

.modal-content
  background-color: white
  width: 80%
  margin: 0 auto
  top: 10%
  position: relative
  padding: 10px
  height: 80vh
  overflow: auto

button 
  cursor:pointer

.close-btn 
  border: 1px solid #000;
  color: #000;
  padding: .75em 4em .75em 4em;


.close-btn-div 
  margin: 0 0 .75em 0;
  text-align: center;

.close-btn:hover 
  border-color: #33404f;
  background-color: #33404f;
  color: #fff;



// .opp-details 
//   font-size: 14px;


// /*****************************************/
// //company info block
// /*****************************************/
#notEnoughInfo 
  margin-top: 2em;
  background-color: firebrick;
  h5 
    color: white !important;



.info-container, .curr-container 
  padding: 0 1em 0 1em;

/* bmr: cancel some heinous thing materialize is doing */
.col .row 
  margin: auto
  


// /*****************************************/
// //icon css
// /*****************************************/
.row
  margin-bottom: 0px

.edit-div .col
  height: 0;
  padding-right: 0;

.edit-icon
  position: relative;
  z-index: 1000;
  width: 15px;
  height: 15px;


.edit-icon:hover, .edit-curr-img:hover
  cursor: pointer;
  cursor: hand;


// /*****************************************/
// //personal info css
// /*****************************************/


</style>